import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({showHomeOnly}) => {
  return (
    <div className='top-0 left-0 right-0 z-20 p-2 sm:p-6'>
      <div className='flex flex-col sm:flex-row gap-3 sm:gap-0 justify-between items-center max-w-6xl mx-auto bg-white/95 backdrop-blur rounded-lg shadow-lg px-5 py-4 sm:px-7 sm:py-5'>
        <nav
          aria-label='Primary navigation'
          className='flex items-center gap-2'
        >
          <Link
            to='/'
            className='inline-flex items-center justify-center rounded-md border border-teal-600 px-4 py-2 text-sm font-bold text-teal-600 transition-colors hover:bg-teal-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2'
          >
            Home
          </Link>
          {!showHomeOnly && (
            <Link
              to='/trinethra'
              className='inline-flex items-center justify-center rounded-md border border-teal-600 px-4 py-2 text-sm font-bold text-teal-600 transition-colors hover:bg-teal-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2'
            >
              Trinethra
            </Link>
          )}
        </nav>
        {/* <button className='w-full sm:w-auto bg-teal-600 text-white px-5 py-2 rounded-full font-semibold hover:bg-teal-700 transition-colors'>
              Get demo
            </button> */}
      </div>
    </div>
  );
};

export default Header;
